export { Pagination } from './Pagination';
export { pageSlots } from './Pagination.pages';
export type { PageSlot } from './Pagination.pages';
export type {
  NavigatedPaginationProps,
  PaginationProps,
  PickedPaginationProps,
} from './Pagination.types';
